<template lang="pug">
  include ./../../mixins
  +b.order-wrapper
    order-creating(
      :url="url"
      v-if="!orderLink"
      :employees-list-url="employeesListUrl"
      :services-list-url="servicesListUrl"
      @order-created="orderCreated"
    )
    order-response(
      v-if="orderLink"
      :order-link="orderLink"
    )
</template>

<script>
export default {
  props: {
    url: String,
    employeesListUrl: String,
    servicesListUrl: String,
  },
  data() {
    return {
      orderLink: null,
    }
  },
  methods: {
    orderCreated(data) {
      this.orderLink = data
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Order/Order.vue